<template>
  <div class="activity-template-content">
    <div class="title">温馨提示</div>
    <div class="content">
      <p>您有一笔未完成的{{vipsName[payStatusInfo.memberType]}}{{['SC_HY','SC1_HY'].includes(payStatusInfo.memberType)?'SVIP':'VIP'}}支付交易</p>
    </div>
    <div class="button-group">
      <nd-button
        class="btn"
        @click="jumpMiddle(payStatusInfo,'continue')"
      >继续支付</nd-button>
      <div
        class="giveup-btn"
        @click='giveup'
      >放弃支付 </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      vipsName: {
        'BC_M': '月卡', 
        'BC_HY': '半年卡', 
        'BC_Y': '年卡'
      }
    }
  },
  props: {
    payStatusInfo: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    ...mapActions('vip', [
      'orderCancel'
    ]),
    // 放弃支付
    async giveup () {
      const res = await this.orderCancel({
        orderNo: this.payStatusInfo.exPaySerialNo
      })
      if (res.success) {
        this.$emit('close')
      }
    },
    jumpMiddle (payStatusInfo, modeOfPayment) {
      this.$emit('jumpMiddle', payStatusInfo, modeOfPayment)
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/less/mixin.less";

.activity-dialog {
    border-radius: 30px;
    .default-content {
      background: linear-gradient(90deg, #fef6e4 0%, #fcd5ac 100%) !important;
      .activity-template-content {
        width: 620px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px;

        .title {
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #763e12;
          line-height: 45px;
          text-align: center;
        }
        .content {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763e12;
          line-height: 37px;
          padding: 20px 0;
        }
        .btn {
          width: 440px;
          height: 74px;
          line-height: 74px;
          margin-top: 30px;
          background: linear-gradient(270deg, #d79663 0%, #e4b378 100%);
        }
        .giveup-btn {
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763e12;
          line-height: 40px;
          text-align: center;
          margin-top: 30px;
        }
        .xy-tips {
          color: #763e12;
          text-align: center;
          margin-top: 30px;
          .active {
            color: #763e12;
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>